/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not by itself. A typed-name image is a visual stand-in for a signature, useful for informal documents, drafts, or footers. If you need a legally enforceable e-signature with an audit trail, use a dedicated e-signature platform instead of this tool.`)
};

const es_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No por sí sola. Una imagen de nombre escrito es un sustituto visual para una firma, útil para documentos informales, borradores o pies de página. Si necesitas una firma electrónica legalmente exigible con un registro de auditoría, usa una plataforma de firma electrónica dedicada en lugar de esta herramienta.`)
};

const de_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht von selbst. Ein getipptes Namensbild ist ein visueller Stellvertreter für eine Signatur, nützlich für informelle Dokumente, Entwürfe oder Fußzeilen. Wenn Sie eine rechtlich durchsetzbare elektronische Signatur mit einem Audit-Trail benötigen, verwenden Sie stattdessen eine dedizierte E-Signatur-Plattform.`)
};

const nl_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet op zichzelf. Een afbeelding met getypte naam is een visueel surrogaat voor een handtekening, nuttig voor informele documenten, concepten of voetteksten. Als u een juridisch bindende e-handtekening met een audittrail nodig hebt, gebruik dan in plaats van dit gereedschap een speciaal e-ondertekenaarplatform.`)
};

const fr_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas en soi. Une image de nom dactylographié est un remplaçant visuel pour une signature, utile pour les documents informels, les brouillons ou les pieds de page. Si vous avez besoin d'une signature électronique juridiquement exécutoire avec une piste d'audit, utilisez plutôt une plateforme de signature électronique dédiée.`)
};

const it_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non di per sé. Un'immagine con nome dattilografato è un sostituto visivo di una firma, utile per documenti informali, bozze o piè di pagina. Se hai bisogno di una firma elettronica legalmente applicabile con una traccia di controllo, utilizza invece una piattaforma di firma elettronica dedicata anziché questo strumento.`)
};

const pt_br2_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não por si só. Uma imagem de nome digitado é um substituto visual para uma assinatura, útil para documentos informais, rascunhos ou rodapés. Se você precisar de uma assinatura eletrônica legalmente vinculante com trilho de auditoria, use uma plataforma dedicada de assinatura eletrônica em vez desta ferramenta.`)
};

const pt_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não por si só. Uma imagem com nome digitado é um substituto visual para uma assinatura, útil para documentos informais, rascunhos ou rodapés. Se precisar de uma assinatura electrónica legalmente aplicável com registo de auditoria, use uma plataforma de assinatura electrónica dedicada em vez desta ferramenta.`)
};

const ja_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`それ自体ではありません。入力された名前の画像は、署名の視覚的な代わりとなり、非形式的なドキュメント、ドラフト、またはフッターに役立ちます。監査証跡がある法的に強制力のある電子署名が必要な場合は、このツールの代わりに専用の電子署名プラットフォームを使用してください。`)
};

const zh_sig_type_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本身不是。输入名字图像是签名的视觉替代品，适用于非正式文档、草稿或页脚。如果您需要具有审计跟踪的法律上有效的电子签名，请使用专用的电子签名平台，而不是此工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq4_a", locale)
	if (locale === "en") return en_sig_type_faq4_a(inputs)
	if (locale === "es") return es_sig_type_faq4_a(inputs)
	if (locale === "de") return de_sig_type_faq4_a(inputs)
	if (locale === "nl") return nl_sig_type_faq4_a(inputs)
	if (locale === "fr") return fr_sig_type_faq4_a(inputs)
	if (locale === "it") return it_sig_type_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq4_a(inputs)
	if (locale === "pt") return pt_sig_type_faq4_a(inputs)
	if (locale === "ja") return ja_sig_type_faq4_a(inputs)
	return zh_sig_type_faq4_a(inputs)
};